import { Pool } from "../../utils/Pool";
export class SaveCmd {
    static create() {
        return Pool.getItemByClass("SaveCmd", SaveCmd);
    }
    recover() {
        Pool.recover("SaveCmd", this);
    }
    run(context) {
        context.save();
    }
    get cmdID() {
        return SaveCmd.ID;
    }
}
SaveCmd.ID = "Save";
